import React from 'react';
import PropTypes from 'prop-types';
import { unmappedErrorKeys } from './styleErrorTabs.jsx';

// Validation errors with no field to sit under and no tab to badge. Rendered above
// the General card so nothing is silently swallowed. In normal operation every error
// is attributable and this renders nothing.
export default function QrGeneralErrors({ errors }) {
  const keys = unmappedErrorKeys(errors);
  if (keys.length === 0) return null;

  return (
    <ul className="qr-general-errors" data-testid="general-errors" role="alert">
      {keys.flatMap((key) => errors[key].map(
        (message) => <li key={`${key}:${message}`}>{message}</li>,
      ))}
    </ul>
  );
}

QrGeneralErrors.propTypes = { errors: PropTypes.object.isRequired };
